const tableHeader = [
  {
    label: "E-Id",
    type: "workerId",
    toolTipText: "Click for Id Sorting"
  },
  {
    label: "Full Name",
    type: "workerFullName",
    toolTipText: "Click for Name Sorting"
  },
  {
    label: "Reimbursement Type",
    type: "reimbursementType",
    toolTipText: "Click for Type Sorting"
  },
  {
    label: "Created At",
    type: "createdOn",
    toolTipText: "Click for Date Sorting"
  },
  {
    label: "Reason",
    type: "reason",
    toolTipText: "Reason of reimbursement"
  },
  {
    label: "Amount",
    type: "amount",
    toolTipText: "Click for amount sorting"
  },
  {
    label: "Image",
    type: "image",
    toolTipText: "Reimbursement Image"
  }
];

const actionButtons = [
  {
    bool: true,
    name: "hold",
    toolTipColor: "info",
    title: "Hold",
    className: "btn text-black btn-sm btn-warning",
    icon: "mdi mdi-alert-outline",
    toolTipText: "Press to Hold Reimbursement"
  },
  {
    bool: true,
    name: "accept",
    toolTipColor: "info",
    title: "Accept",
    className: "btn text-black btn-sm btn-success",
    icon: "mdi mdi-check-all",
    toolTipText: "Press to Accept Reimbursement"
  },
  {
    bool: true,
    name: "reject",
    toolTipColor: "info",
    title: "Reject",
    className: "btn text-black btn-sm btn-danger",
    icon: "mdi mdi-close-circle-outline",
    toolTipText: "Press to Reject Reimbursement"
  }
];

export { tableHeader, actionButtons };
